module.exports = __webpack_public_path__ + "media/Doug.8f129a17.mp3";